import type { EntitlementsFeatures } from './type';

export const entitlements: EntitlementsFeatures = {
    enabled: true,
    _description:
        'Entitlements option accessible from User Settings. Redirects to local bank system (Dispo) where the user can manage entitlements other subjects may have to products and services of the user.',
};
